"use client"

import { useEffect } from "react"
import * as Sentry from "@sentry/browser"

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="tr">
      <body
        data-testid="beauty-academy-global-error"
        style={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
          padding: "2rem",
          fontFamily: "system-ui, sans-serif",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "1.5rem", fontWeight: 600 }}>Bir hata oluştu</h1>
        <p style={{ color: "#666", maxWidth: "28rem" }}>
          Beklenmeyen bir sorun oluştu. Lütfen tekrar deneyin.
        </p>
        <button
          data-testid="beauty-academy-global-error-retry"
          onClick={() => reset()}
          style={{
            cursor: "pointer",
            borderRadius: "0.5rem",
            border: "none",
            backgroundColor: "#e8457e",
            color: "#fff",
            padding: "0.625rem 1.25rem",
            fontSize: "0.875rem",
            fontWeight: 500,
          }}
        >
          Tekrar dene
        </button>
      </body>
    </html>
  )
}
